(function () {
  'use strict';

  var config = window.boostPFSAppConfig;
  if (!config || !config.general || String(config.general.template).indexOf('collection') !== 0) return;
  var shopifyProductCount = Number(config.general.collection_product_count || 0);
  if (shopifyProductCount < 1) return;
  var collectionId = String(config.general.collection_id || '');
  var dvccCollections = { '686383563133': true, '686383595901': true };

  function hasRealFilter() {
    var active = false;
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (!String(value).trim()) return;
      if (key.indexOf('filter.') === 0 || key.indexOf('pf_') === 0 || key === 'q') active = true;
    });
    return active;
  }

  function wrap(original) {
    if (typeof original !== 'function' || original.__vbCacheGuardWrapped) return original;
    function guardedCallback(data) {
      var boostProductCount = data ? Number(data.total_product || 0) : 0;
      var isUnexpectedEmpty = data && boostProductCount === 0;
      var isStaleDvccSplit = data && dvccCollections[collectionId] && boostProductCount !== shopifyProductCount;
      if (hasRealFilter() || (!isUnexpectedEmpty && !isStaleDvccSplit)) return original.apply(this, arguments);

      // Shopify has already rendered products on the server. If Boost has no
      // index entry yet, do not let its empty response erase valid products.
      var grid = document.querySelector('.boost-pfs-filter-products');
      if (grid) {
        grid.style.removeProperty('display');
        grid.style.removeProperty('visibility');
        grid.style.removeProperty('opacity');
      }
      window.__vbBoostCacheGuard.preventedEmptyRender = true;
    }
    guardedCallback.__vbCacheGuardWrapped = true;
    return guardedCallback;
  }

  var callback = wrap(window.BoostPFSFilterCallback);
  window.__vbBoostCacheGuard = { installed: true, preventedEmptyRender: false };

  // Boost defines its JSONP callback during initialization. Install a setter
  // beforehand so the callback is guarded even when it does not exist yet.
  try {
    Object.defineProperty(window, 'BoostPFSFilterCallback', {
      configurable: true,
      enumerable: true,
      get: function () { return callback; },
      set: function (value) { callback = wrap(value); }
    });
  } catch (error) {
    if (typeof callback === 'function') window.BoostPFSFilterCallback = callback;
  }
})();
